import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attention",
  "use": "attention-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"attention\"><rect y=\".5\" width=\"16\" height=\"16\" rx=\"8\" /><path d=\"M8.727 9.862h-1.43l-.299-5.724h2.027l-.298 5.724Zm-1.752 2.004c0-.328.088-.576.263-.744.176-.168.432-.252.768-.252.324 0 .574.086.75.258.18.172.27.418.27.738 0 .309-.09.553-.27.733-.18.175-.43.263-.75.263-.328 0-.582-.086-.762-.258-.18-.175-.27-.421-.27-.738Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol